export default __webpack_public_path__ + "static/coating-hero-beb858c23c04787c7bc6c9d936e5cd9f.jpg";